import { createUseStyles } from 'react-jss';

/** Height of the pill itself, excluding the wrapper's padding. */
const pillHeight = 40;

const horizontalInset = 12;
const gapBetweenItems = 3;

export const accordionHeight = pillHeight + gapBetweenItems;

export { gapBetweenItems };

export const useStyles = createUseStyles({
  wrapper: {
    height: '100%',
    boxSizing: 'border-box',
    padding: `0 ${horizontalInset}px ${gapBetweenItems}px`,
  },
  pill: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 12,
    padding: '0 13px',
    cursor: 'pointer',
    userSelect: 'none',
    background: 'var(--ion-color-light)',
    transition: 'background-color 120ms ease',
    '&:hover': {
      background: 'rgba(var(--ion-color-dark-rgb), 0.055)',
    },
  },
  expanded: {
    background: 'rgba(var(--ion-color-primary-rgb), 0.08)',
    '&:hover': {
      background: 'rgba(var(--ion-color-primary-rgb), 0.08)',
    },
  },
  iconWrapper: {
    display: 'flex',
    flexShrink: 0,
  },
  icon: {
    fontSize: 8,
    color: 'var(--ion-color-dark)',
    opacity: 0.5,
  },
  iconExpanded: {
    transform: 'rotate(90deg)',
    color: 'var(--ion-color-primary)',
  },
  label: {
    flex: '1 1 auto',
    minWidth: 0,
    marginLeft: 11,
    fontWeight: 500,
    fontSize: 14,
    color: 'var(--ion-color-dark)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  labelExpanded: {
    color: 'var(--ion-color-primary)',
  },
  count: {
    marginLeft: 'auto',
    flexShrink: 0,
    padding: '3px 7px',
    borderRadius: 6,
    fontSize: 10,
    fontWeight: 400,
    background: 'rgba(var(--ion-color-dark-rgb), 0.05)',
    color: 'rgba(var(--ion-color-dark-rgb), 0.45)',
  },
  countExpanded: {
    background: 'rgba(var(--ion-color-primary-rgb), 0.16)',
    color: 'var(--ion-color-primary)',
  },
});
